<template>
  <b-card>
    <template #header>
      <h4 class="mb-0">
        {{ documentRequestData.name }}
      </h4>
    </template>
    <b-row>
      <!-- User Info: Left col -->
      <b-col
        cols="6"
        class="d-flex flex-column"
      >
        <h5
          class="d-flex justify-content-between"
          style="text-transform: capitalize"
        >
          {{ $t('documentRequests.title.processer') + ': ' + documentRequestData.processer }}
        </h5>

        <hr>

        <div class="d-flex flex-column">
          <div class="mb-1">
            <h5
              class="d-flex justify-content-between"
              style="text-transform: capitalize"
            >
              {{ $t('documentRequests.title.receiver') + ': ' + documentRequestData.user.fullName }}
            </h5>
            <p class="card-text">
              <feather-icon
                icon="MailIcon"
                class="mr-75"
              />
              {{ documentRequestData.user.email }}
            </p>
          </div>
        </div>
      </b-col>

      <!-- Right Col: Table -->
      <b-col
        cols="6"
      >
        <table class="mt-4 mt-xl-0 w-100">
          <tr>
            <th class="pb-50">
              <span class="font-weight-bold">{{ $t('documentRequests.title.status') }}</span>
            </th>
            <td class="pb-50 text-capitalize">
              {{ documentRequestData.status }}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <span class="font-weight-bold">{{ $t('documentRequests.title.mandatory') }}</span>
            </th>
            <td class="pb-50 text-capitalize">
              {{ documentRequestData.mandatory }}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <span class="font-weight-bold">{{ $t('documentRequests.title.deadline') }}</span>
            </th>
            <td class="pb-50 text-capitalize">
              {{
                documentRequestData.deadline
                  .toDate()
                  .toLocaleString('fi', {
                    dateStyle: 'short',
                    timeStyle: 'short'
                  })
              }}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <span class="font-weight-bold">{{ $t('documentRequests.title.requestAt') }}</span>
            </th>
            <td class="pb-50 text-capitalize">
              {{
                documentRequestData.requestedAt
                  .toDate()
                  .toLocaleString('fi', {
                    dateStyle: 'short',
                    timeStyle: 'short'
                  })
              }}
            </td>
          </tr>
        </table>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { BCard, BRow, BCol } from 'bootstrap-vue'
import { avatarText } from '@hw-ui/utils/filter'

export default {
  components: {
    BCard,
    BRow,
    BCol,
  },
  props: {
    documentRequestData: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const getAddress = address => {
      let str = ''
      str = `${address.streetAddress} ${address.postcode} ${address.city} ${address.state}`
      return str
    }

    return {
      avatarText,
      getAddress,
    }
  },
}
</script>

<style></style>
